import { render, staticRenderFns } from "./DialogAplicarCompraSazonal.vue?vue&type=template&id=61274d2d&scoped=true"
import script from "./DialogAplicarCompraSazonal.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogAplicarCompraSazonal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DialogAplicarCompraSazonal.vue?vue&type=style&index=0&id=61274d2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61274d2d",
  null
  
)

export default component.exports